import { useCallback, useRef, useState } from 'react'

import { CustomCmsSeller } from '../../../../domain/seller'
import ListSellers from '../ListSellers'
import SellerPageStructure from '../SellerPageStructure'
import { scrollToSeller, setInfoWindowContent } from '../helper'
import { SellersPageProps } from '../types'

import { BaiduHTMLSellersMapId } from './constants'
import BaiduSellersFiltersMap from './BaiduSellersFiltersMap'
import useBaiduSellersMap from './useSellersBaiduMap'

const BaiduSellersPage = ({ sellers, onSubmitFilterForm, filters }: SellersPageProps) => {
  const [selectedStore, setSelectedStore] = useState<CustomCmsSeller>()
  const filtersRef = useRef(filters)
  filtersRef.current = filters
  const { mapRef, markersRef } = useBaiduSellersMap(sellers, {
    onClickMarker: (seller) => {
      setSelectedStore(seller)
      scrollToSeller(seller)
    },
    onZoomEnd(map) {
      const zoom = map.getZoom()
      if (zoom < 11) {
        onSubmitFilterForm({
          ...filtersRef.current,
          radius: undefined,
        })
      }
    },
  })

  const centerMapFromLatLng = useCallback(
    (lat: number, lng: number, zoom = 12) => {
      try {
        mapRef.current?.centerAndZoom(new BMap.Point(lng, lat), zoom)
      } catch (e) {
        console.warn(e) // eslint-disable-line
      }
    },
    [mapRef],
  )

  const centerMapFromCityName = useCallback(
    (cityName: string, zoom = 12) => {
      mapRef.current?.centerAndZoom(cityName, zoom)
    },
    [mapRef],
  )

  const onSelectStore = (seller: CustomCmsSeller) => {
    try {
      setSelectedStore(seller)

      // center map on selected store
      centerMapFromLatLng(Number(seller.latitude), Number(seller.longitude), 15)

      // Open info window of selected store
      const marker = markersRef.current?.find((item) => item.id === seller.id)

      if (marker) {
        const size = mapRef.current?.getSize() ?? { width: 0, height: 0 }

        const infoWindow = new BMap.InfoWindow(setInfoWindowContent(seller), {
          offset: new BMap.Size(0, -30),
          width: size?.width >= 300 ? 290 : size?.width - 150,
          maxWidth: 300,
        })

        mapRef.current?.openInfoWindow(infoWindow, marker.getPosition())
      }
    } catch (e) {
      console.warn(e) // eslint-disable-line
    }
  }

  return (
    <SellerPageStructure>
      <BaiduSellersFiltersMap
        onSubmitFilterForm={onSubmitFilterForm}
        centerMapFromLatLng={centerMapFromLatLng}
        centerMapFromCityName={centerMapFromCityName}
      />
      <div id={BaiduHTMLSellersMapId} className='map-sellers-baidu' />
      <ListSellers
        sellers={sellers}
        filters={filters}
        selectedStore={selectedStore}
        onSelectStore={onSelectStore}
      />
    </SellerPageStructure>
  )
}

export default BaiduSellersPage
